import { render, staticRenderFns } from "./TaskInlineDetail.vue?vue&type=template&id=9f13f272&"
import script from "./TaskInlineDetail.vue?vue&type=script&lang=js&"
export * from "./TaskInlineDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports